import React, {useEffect, useRef, useState} from 'react';
import {Box, Button, TableCell, TableRow, Typography} from "@mui/material";
import {AsyncImageWithLoader} from "../../../../../../../com/imageWithLoader/imageWithLoader";
import {
    MenuForPromotion
} from "../../../../../promos/leftMenu/LeftMenuContent/LeftMenuContentElement/MenuForPromotions/menuForPromotions";
import {
    AccountStoreSettingDto,
    ItemsListMenuDto,
    StoreShelfStylesDto
} from "../../../../../../../dtos";
import {ReactComponent as CameraIcon} from "../../../../../../../assets/camera_icon.svg";
import {ReactComponent as MenuOnHover} from "../../../../../../../assets/flyersScreen/3_dots_icon.svg";
import {makeStyles} from "@mui/styles";
import {useTypedSelector} from "../../../../../../../hooks/useTypeSelector";

const useStyles = makeStyles(() => ({
    tableRow: {
        "& > .MuiTableCell-root": {
            textAlign: "center",
            borderTop: "1px solid #dee2e6",
            padding: 0,
            borderRight: "2px solid #e2e2e2",
            borderBottom: "none"
        },
        '&.onHoverEffect': {
            backgroundColor: "#e4e4e480",
        }
    },
    cellBox: {
        height: `100%`,
        display: `flex`,
        alignItems: `center`,
        justifyContent: `center`,
    },
    storeMainColor: {
        width: "100%",
        height: "100%",
        borderRadius: "50%"
    }
}))

interface Props {
    storeSettingData: AccountStoreSettingDto;
    setIsCloseMenu: (value: boolean) => void;
    isCloseMenu: boolean;
    onEdit: (storeSettingData: AccountStoreSettingDto) => void;
    onDelete: (storeSettingData: AccountStoreSettingDto) => void;
    setDefaultSettingForStore: (storeSettingData: AccountStoreSettingDto) => void;
}

const StoreSettingsRow: React.FC<Props> = ({
                                               storeSettingData,
                                               setIsCloseMenu,
                                               isCloseMenu,
                                               onEdit,
                                               onDelete,
                                               setDefaultSettingForStore
                                           }) => {
    const anchorRefForMenu = useRef(null);
    const storeShelfStyles: StoreShelfStylesDto = useTypedSelector((state) => state.storeShelfStyles);
    const shelfStyleData = storeShelfStyles.storeShelfStyles.find((shelfStyle) => {
        if(shelfStyle.id === storeSettingData.storeShelfStyleId){
            return shelfStyle;
        }
    })
    const [isHoverOnRow, changeStatusForHoverOnRow] = useState<boolean>(false);
    const [isOpenedMenu, setOpenMenu] = useState(false);
    const prevOpenMenu = useRef(isOpenedMenu);
    const classes = useStyles();

    useEffect(() => {
        setIsCloseMenu(!isOpenedMenu);
    }, [isOpenedMenu]);

    useEffect(() => {
        if (isCloseMenu && isOpenedMenu) {
            setOpenMenu(!isOpenedMenu);
        }
    }, [isCloseMenu]);

    const onDeleteStoreSetting = () => {
        // if (props.dto.isDeleteable) {
        onDelete(storeSettingData);
        onMouseLeaveRow();
        // }
    }
    const onEditStoreSetting = () => {
        onEdit(storeSettingData);
        onMouseLeaveRow()
    }
    const setDefaultStoreSetting = () => {
        setDefaultSettingForStore(storeSettingData)
        onMouseLeaveRow()
    }
    const onMouseEnterRow = () => {
        changeStatusForHoverOnRow(true);
    }

    const onMouseLeaveRow = () => {
        changeStatusForHoverOnRow(false);
        setOpenMenu(false);
    }

    const handleToggleForFlyer = () => {
        setOpenMenu((prevOpen) => !prevOpen);
    };

    const clickMenuDataForFlyer: ItemsListMenuDto = {
        setOpen: setOpenMenu,
        prevOpen: prevOpenMenu,
        open: isOpenedMenu,
        anchorRef: anchorRefForMenu,
    };


    return (
        <TableRow
            className={`${isHoverOnRow ? "onHoverEffect" : ""} ${classes.tableRow}`} key={1}
            onMouseEnter={onMouseEnterRow}
            onMouseLeave={onMouseLeaveRow}
        >
            <TableCell>
                <Box className={classes.cellBox}>
                    <Typography sx={{
                        wordBreak: "break-all"
                    }}>
                        {storeSettingData.caption}{storeSettingData.isDefaultAccountStoreSetting && " (Default)"}
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox} sx={{
                    backgroundColor: storeSettingData.primaryColorRgb ? storeSettingData.primaryColorRgb : '#ffffff'
                }}>
                    <Box sx={{
                        width: `100%`,
                        height: `52px`,
                        maxWidth: `100%`,
                        maxHeight: `52px`,
                        display: `flex`,
                        alignItems: `center`,
                        justifyContent: `center`,
                        margin: `4px 8px`
                    }}>
                        {
                            storeSettingData && storeSettingData.logoUrl &&
                            <AsyncImageWithLoader
                                src={storeSettingData.logoUrl ? storeSettingData.logoUrl : 'https://'}
                                notUploadIcon={(<CameraIcon/>)}
                            />
                        }
                    </Box>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox}>
                    <Box sx={{width: `20px`, height: `20px`}}>
                        <Box className={classes.storeMainColor} style={{
                            backgroundColor: storeSettingData.primaryColorRgb ? storeSettingData.primaryColorRgb : '#0000FF'
                        }}/>
                    </Box>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox}>
                    <Box sx={{
                        width: `50px`,
                        height: `50px`,
                        maxWidth: `50px`,
                        maxHeight: `50px`,
                        border: `1px solid #E2E2E2`,
                        margin: `5px 0`,
                        borderRadius: `5px`,
                        backgroundColor: "#ffffff"
                    }}>
                        {
                            storeSettingData.backgroundImageUrl && !Boolean(storeSettingData.backgroundColorRgb)
                                ? <AsyncImageWithLoader
                                    src={storeSettingData.backgroundImageUrl}
                                    notUploadIcon={(<CameraIcon/>)}
                                />
                                : <div style={{
                                    backgroundColor: storeSettingData.backgroundColorRgb ? storeSettingData.backgroundColorRgb : '#ffffff',
                                    height: `100%`,
                                    width: `100%`,
                                    borderRadius: `5px`,
                                }}/>

                        }
                    </Box>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox}>
                    <Box sx={{
                        display: `flex`,
                        alignItems: `center`,
                        height: "24px",
                        width: "100%",
                        padding: "0 16px"
                    }}>

                        {
                            shelfStyleData && shelfStyleData.textureImageUrl &&
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    flexFlow: "column"
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "49%",
                                        backgroundImage: `url(${shelfStyleData.textureImageUrl})`,
                                        backgroundSize: "cover",
                                        clipPath: "polygon(10% 0, 90% 0, 100% 102%, 0% 102%)",
                                        opacity: "0.8"
                                    }}
                                >
                                </Box>
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "51%",
                                        backgroundImage: `url(${shelfStyleData.textureImageUrl})`,
                                        backgroundSize: "cover",
                                    }}
                                >
                                </Box>
                            </Box>
                        }
                        {
                            shelfStyleData && !shelfStyleData.textureImageUrl &&
                            <Box
                                sx={{
                                    width: "100%",
                                    height: "100%"
                                }}
                            >
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "50%",
                                        borderBottom: `12px solid ${shelfStyleData.colorRgb || "red"}80`,
                                        borderLeft: "7px solid transparent",
                                        borderRight: "7px solid transparent",
                                    }}
                                >
                                </Box>
                                <Box
                                    sx={{
                                        width: "100%",
                                        height: "50%",
                                        backgroundColor: `${shelfStyleData.colorRgb || "red"}`
                                    }}
                                >
                                </Box>
                            </Box>
                        }
                    </Box>
                </Box>
            </TableCell>
            <TableCell>
                <Box className={classes.cellBox}>
                    <Typography fontFamily={storeSettingData.font?.toLowerCase()} fontSize={`14px`}>
                        {
                            storeSettingData.font === 'OpenSans' ?
                                'Open Sans' :
                                (
                                    storeSettingData.font === 'AlmoniTzar' ?
                                        'Almoni Tzar (Hebrew)' :
                                        (
                                            storeSettingData.font === 'OpenSansHeb' ?
                                                'Open Sans (Hebrew)' :
                                                storeSettingData.font
                                        )
                                )
                        }
                    </Typography>
                </Box>
            </TableCell>
            <TableCell>
                {isHoverOnRow &&
                    <Box
                        className={`${classes.cellBox}`}
                    >
                        <Button
                            sx={{
                                width: "24px",
                                height: "24px",
                                "&:hover": {
                                    backgroundColor: "#88888833"
                                }
                            }}
                            ref={anchorRefForMenu}
                            aria-controls={
                                isOpenedMenu
                                    ? "menu-list-grow"
                                    : undefined
                            }
                            aria-haspopup="true"
                            onClick={handleToggleForFlyer}
                        >
                            <MenuOnHover style={{pointerEvents: "none"}}/>
                        </Button>
                        <MenuForPromotion
                            list={clickMenuDataForFlyer}
                            deleteStoreSetting={onDeleteStoreSetting}
                            // handleDeleteClick={userDto.accountTier === 1 ? handleDeleteClick : softDeleteFlyer}
                            editStoreSetting={onEditStoreSetting}
                            setDefaultStoreSetting={setDefaultStoreSetting}
                            isDisabledContextMenuOption={storeSettingData.isDefaultAccountStoreSetting || false}
                            infoForMenu={`menuForStoreSetting`}
                            // isDisableDelete={!props.dto.isDeleteable}
                        />
                    </Box>
                }
            </TableCell>
        </TableRow>

    )
}

export default StoreSettingsRow;